import { RouterProvider } from "react-router-dom";
import { AppErrorBoundary } from "@/components/errors/AppErrorBoundary";
import { AppProviders } from "@/app/providers";
import { router } from "@/app/router";

export default function App() {
  return (
    <AppErrorBoundary>
      <AppProviders>
        <RouterProvider router={router} />
      </AppProviders>
    </AppErrorBoundary>
  );
}
